import React, { Component, useState } from "react";

import RichBox from "./RichBoxComponent";
import axios from "axios";
import { BASE_URL } from "../../../variables/api";
import Select from "react-select";
import { useSelector } from "react-redux";

// const selectedStyle = {
//   cursor: "pointer",
//   backgroundColor: "#9df3b1 !important",
//   border: "4px solid #098434 !important",
//   borderRadius: "10px !important",
// };

const LearningStandards = (props: any) => {
  /*   state = {
      id:props.id,
      option:props.option ?? "",
      authorNote:props.authorNote ?? "",
    }; */
  // static getDrivedStateFromProps() {

  // }
  const user = useSelector((storeState: any) => storeState.user);

  const [state, setState] = useState({
    targets: props.all_targets?.length > 0 ? [...props.all_targets] : [],
  });
  const GetTargets = (standard_id: any) => {
    axios
      .get(`${BASE_URL}/admin/gettargets.php?id=${standard_id}`)
      .then((response) => {
        setState({ targets: response.data.data });
        props.updateTargets(response.data.data);
      });
  };

  return (
    <div className="col-12 row m-0 p-0 align-items-center align-items-center ">
      {!user?.isExternalUser && (
        <>
          <div className="col-sm-6">
            <label className="text-white ml-1">Learning standard: </label>
            <Select
              styles={{
                control: (provided) => ({
                  ...provided,
                  color: "black", // Color of text inside the control area (selected option)
                }),
                option: (provided, state) => ({
                  ...provided,
                  color: "black", // Color of the option text
                }),
              }}
              options={props.coursestandards?.map((standard: any) => {
                return {
                  value: standard.standard_id,
                  label: standard.learning_outcome,
                };
              })}
              isClearable
              placeholder="Select learning standard..."
              onChange={(selectedOption: any) => {
                let standard_id = selectedOption?.value || "";

                if (!standard_id) {
                  props.onChangeStanderd("");
                  setState({ targets: [] });
                  props.updateTargets([]);
                  return;
                }

                GetTargets(standard_id);
                props.onChangeStanderd(standard_id);
              }}
              value={
                props.coursestandards?.find(
                  (standard: any) =>
                    standard.standard_id == props.question?.standardid
                )
                  ? {
                      value: props.question?.standardid,
                      label: props.coursestandards?.find(
                        (standard: any) =>
                          standard.standard_id == props.question?.standardid
                      )?.learning_outcome,
                    }
                  : null
              }
            />
          </div>

          <div className="col-sm-6">
            <label className="text-white ml-1">Learning targets: </label>
            <Select
              styles={{
                control: (provided) => ({
                  ...provided,
                  color: "black", // Color of text inside the control area (selected option)
                }),
                option: (provided, state) => ({
                  ...provided,
                  color: "black", // Color of the option text
                }),
              }}
              options={state.targets?.map((target: any) => {
                return { value: target.id, label: target.title };
              })}
              isMulti
              placeholder="Select learning targets..."
              onChange={(e: any) => {
                let target_ids = e?.map((target: any) => +target.value);
                if (!target_ids) {
                  target_ids = [];
                }
                props.onChangeTargets(target_ids);
              }}
              value={state.targets
                ?.filter((t: any) =>
                  props.question?.learning_targets?.includes(+t.id)
                )
                .map((target: any) => {
                  return { value: target.id, label: target.title };
                })}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default LearningStandards;
